import request from '@/utils/request'
import { parseStrEmpty } from "@/utils/ruoyi";


export function getNews() {
    return request({
      url: '/system/gwv/getNews',
      method: 'get'
    })
}

export function getColumnByTesting() {
  return request({
    url: '/system/gwv/getColumnByTesting',
    method: 'get'
  })
}

export function getNotice() {
  return request({
    url: '/system/gwv/getNotice',
    method: 'get'
  })
}

export function getData() {
  return request({
    url: '/system/gwv/getData',
    method: 'get'
  })
}

export function getParty() {
  return request({
    url: '/system/gwv/getParty',
    method: 'get'
  })
}

export function getSense() {
  return request({
    url: '/system/gwv/getSense',
    method: 'get'
  })
}
export function getPartyImg() {
  return request({
    url: '/system/gwv/getPartyImg',
    method: 'get'
  })
}

// 查询栏目详细
export function getJgjjData(id) {
  return request({
    url: 'system/gwv/' + parseStrEmpty(id),
    method: 'get'
  })
}

export function getDataInfo(query) {
  return request({
    url: 'system/gwv/info',
    method: 'get',
    params: query
  })
}

export function getColumnList(id) {
  return request({
    url: 'system/gwv/column/' + parseStrEmpty(id),
    method: 'get'
  })
}

export function getDatailsInfo(id) {
  return request({
    url: 'system/gwv/details/' + parseStrEmpty(id),
    method: 'get'
  })
}

export function getDatailsColumnList(id) {
  return request({
    url: 'system/gwv/column/' + parseStrEmpty(id),
    method: 'get'
  })
}

export function getCodeImg() {
  return request({
    url:'/captchaImage',
    method: 'get'
  })
}

export function registerUser(data) {
  return request({
    url: '/user/login/register',
    method: 'post',
    data: data
  })
}

export function userLogin(data) {
  return request({
    url: '/user/login/login',
    method: 'post',
    data: data
  })
}

//获取用户信息
export function getUser(id) {
  return request({
    url: '/user/login/' + id,
    method: 'get'
  })
}
//修改用户
export function updateUser(data) {
  return request({
    url: '/user/login',
    method: 'put',
    data: data
  })
}
//修改密码
export function updatePassword(data) {
  return request({
    url: '/user/login/new',
    method: 'put',
    data: data
  })
}


export function getWordInfo(query) {
  return request({
    url: '/content/word/getlist',
    method: 'get',
    params: query
  })
}

// 新增【请填写功能名称】
export function addWord(data) {
  return request({
    url: '/content/word',
    method: 'post',
    data: data
  })
}

// 查询栏目详细
export function getWordData(id) {
  return request({
    url: '/content/word/info/' + parseStrEmpty(id),
    method: 'get'
  })
}

export function getUsers(id) {
  return request({
    url: '/system/gwv/user/' + id,
    method: 'get'
  })
}
















// WEBPACK FOOTER //
// ./src/api/content/column.js